import { Timestamp, deleteField } from 'firebase/firestore'

/** قراءة كوبون من Firestore — أسماء الحقول كما في تطبيق العميل */
export function normCouponFromDoc(docId, data) {
  const raw = data && typeof data === 'object' ? data : {}
  let endDate = null
  if (raw.end_date?.toDate) {
    endDate = raw.end_date.toDate()
  } else if (raw.end_date instanceof Date) {
    endDate = raw.end_date
  }

  return {
    id: String(docId || raw.id || '').trim(),
    code: String(raw.code || '').trim(),
    where: String(raw.where || '').trim(),
    discount: String(raw.discount ?? '0').trim(),
    upto: Math.max(0, Math.floor(Number(raw.upto) || 0)),
    offer_in_total: raw.offer_in_total === true,
    for_all_res: raw.for_all_res !== false,
    based_on_count: raw.based_on_count === true || raw.baesd_on_count === true,
    based_on_date: raw.based_on_date === true,
    count: Math.max(0, Math.floor(Number(raw.count) || 0)),
    end_date: endDate,
    restaurants: Array.isArray(raw.restaurants) ? raw.restaurants.map(String) : [],
    users: Array.isArray(raw.users) ? raw.users.map(String) : []
  }
}

export function couponUsageCount(coupon) {
  return Array.isArray(coupon?.users) ? coupon.users.length : 0
}

export function couponValidityLabel(coupon) {
  if (coupon?.based_on_date) {
    if (!coupon.end_date) return 'تاريخ — بدون end_date'
    return `حتى ${formatCouponDate(coupon.end_date)}`
  }
  if (coupon?.based_on_count) {
    const used = couponUsageCount(coupon)
    const max = coupon.count || 0
    return `${used} / ${max} استخدام`
  }
  return '—'
}

export function formatCouponDate(d) {
  if (!d) return '—'
  try {
    return new Intl.DateTimeFormat('ar-EG', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(d instanceof Date ? d : new Date(d))
  } catch {
    return String(d)
  }
}

function parsePositiveInt(value, fallback = 0) {
  const n = Math.floor(Number(String(value ?? '').replace(/\D/g, '') || 0))
  return Number.isFinite(n) && n >= 0 ? n : fallback
}

/**
 * @param {object} form
 * @param {{ existingUsers?: string[], docId?: string }} opts
 */
export function buildCouponWritePayload(form, opts = {}) {
  const existingUsers = Array.isArray(opts.existingUsers) ? opts.existingUsers : []
  const resetUsers = form.resetUsers === true
  const basedOnCount = form.based_on_count === true

  const payload = {
    code: String(form.code || '').trim().toUpperCase(),
    where: String(form.where || '').trim(),
    discount: String(parsePositiveInt(form.discount, 0)),
    upto: parsePositiveInt(form.upto, 0),
    offer_in_total: form.offer_in_total === true,
    for_all_res: form.for_all_res === true,
    based_on_count: basedOnCount,
    based_on_date: form.based_on_date === true,
    count: basedOnCount ? Math.max(1, parsePositiveInt(form.count, 1)) : 0,
    restaurants: form.for_all_res
      ? []
      : (Array.isArray(form.restaurantIds) ? form.restaurantIds.map(String) : []),
    users: resetUsers ? [] : existingUsers
  }

  if (opts.isUpdate) {
    payload.baesd_on_count = deleteField()
  }

  if (opts.docId) {
    payload.id = String(opts.docId).trim()
  }

  if (form.based_on_date && form.end_date) {
    const d = form.end_date instanceof Date ? form.end_date : new Date(form.end_date)
    if (!Number.isNaN(d.getTime())) {
      payload.end_date = Timestamp.fromDate(d)
    }
  } else if (opts.isUpdate) {
    payload.end_date = deleteField()
  }

  return payload
}

export const COUPON_ENTITY_KINDS = [
  { value: 'restaurants', label: 'مطاعم', collection: 'categories', categoryType: 1 },
  { value: 'pharmacies', label: 'صيدليات', collection: 'categories', categoryType: 3 },
  { value: 'shops', label: 'محلات', collection: 'shops', shopLab: false }
]

export function couponEntityKindLabel(value) {
  return COUPON_ENTITY_KINDS.find((k) => k.value === value)?.label || 'كيانات'
}

export function emptyCouponForm() {
  return {
    id: '',
    code: '',
    where: '',
    entityKind: 'restaurants',
    discount: '10',
    upto: '15',
    offer_in_total: false,
    for_all_res: true,
    based_on_count: true,
    based_on_date: false,
    count: '1',
    end_date: null,
    restaurantIds: [],
    resetUsers: false
  }
}

export function couponFormFromRow(row, entityKind = 'restaurants') {
  return {
    id: row.id,
    code: row.code,
    where: row.where,
    entityKind,
    discount: String(row.discount ?? '0'),
    upto: String(row.upto ?? '0'),
    offer_in_total: row.offer_in_total,
    for_all_res: row.for_all_res,
    based_on_count: row.based_on_count,
    based_on_date: row.based_on_date,
    count: String(row.count ?? '1'),
    end_date: row.end_date ? new Date(row.end_date) : null,
    restaurantIds: [...(row.restaurants || [])],
    resetUsers: false
  }
}
